import {
  SEND_EMAIL_ENDPOINT_URL,
  HOSTNAME,
  SEND_EMAIL_API_KEY,
  SEND_EMAIL_FROM,
  SEND_EMAIL_NAME,
  SEND_EMAIL_REPLY,
} from '@/env';

import { post } from '@ajorquera/libs/utils';
import { Dict, getStrTemplate } from '@ajorquera/libs/utils';
import emailTemplateConfig from './emailTemplates.config';
import { render } from '@react-email/render';
import EmailTemplate, { Props as EmailTemplateProps } from './EmailTemplate';

export interface SendEmailProps {
  to: string;
  templateName: keyof typeof emailTemplateConfig;
  props: Dict;
}

const isEmail = (email: string) => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(email);
};

const sendEmail = async ({ to, templateName, props }: SendEmailProps) => {
  const mergeProps = { ...props, hostname: HOSTNAME };
  const emailConfig = emailTemplateConfig[templateName];

  if (!isEmail(to)) throw new Error('Invalid email address');
  if (!emailConfig) return;

  const emailProps = processEmailConfig(emailConfig, mergeProps) as EmailTemplateProps;

  const emailNode = await render(<EmailTemplate {...mergeProps} {...emailProps} />);

  return post({
    url: SEND_EMAIL_ENDPOINT_URL,
    body: {
      to,
      subject: emailProps.subject as string,
      body: emailNode,
      name: SEND_EMAIL_NAME,
      reply: SEND_EMAIL_REPLY,
      from: SEND_EMAIL_FROM,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${SEND_EMAIL_API_KEY}`,
    },
  });
};

export default sendEmail;

const processEmailConfig = (emailConfig: Dict<string>, props: Dict) => {
  return Object.entries(emailConfig).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      acc[key] = value.map((item) => getStrTemplate(item, props));
    } else {
      acc[key] = getStrTemplate(value as string, props);
    }

    return acc;
  }, {});
};
